<template>
  <div class="loading text-center d-flex flex-column justify-center align-center">
    <v-progress-circular
      indeterminate
      size="72"
      :color="color"
    ></v-progress-circular>
      <h1 class="white--text mt-4 text-center">{{text}}</h1>
    </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
    text: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style scoped>
  .white--text{
    color: #1A237E !important;
  }
  .loading {
    height: inherit;
  }
</style>